/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explore_The_Marketplace_AndInputs */

const en_explore_the_marketplace_and = /** @type {(inputs: Explore_The_Marketplace_AndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore the marketplace and heart items to save them here.`)
};

const es_explore_the_marketplace_and = /** @type {(inputs: Explore_The_Marketplace_AndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explora el mercado y marca con corazón los artículos para guardarlos aquí.`)
};

const fr_explore_the_marketplace_and = /** @type {(inputs: Explore_The_Marketplace_AndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explorez la marketplace et mettez des cœurs sur les articles pour les enregistrer ici.`)
};

const de_explore_the_marketplace_and = /** @type {(inputs: Explore_The_Marketplace_AndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erkunde den Marktplatz und markiere Artikel mit einem Herz, um sie hier zu speichern.`)
};

const id_explore_the_marketplace_and = /** @type {(inputs: Explore_The_Marketplace_AndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jelajahi marketplace dan beri hati item untuk menyimpannya di sini.`)
};

/** @type {(inputs: Explore_The_Marketplace_AndInputs) => LocalizedString} */
const ja_explore_the_marketplace_and = en_explore_the_marketplace_and;

/** @type {(inputs: Explore_The_Marketplace_AndInputs) => LocalizedString} */
const zh_explore_the_marketplace_and = en_explore_the_marketplace_and;

/** @type {(inputs: Explore_The_Marketplace_AndInputs) => LocalizedString} */
const ar_explore_the_marketplace_and = en_explore_the_marketplace_and;

/** @type {(inputs: Explore_The_Marketplace_AndInputs) => LocalizedString} */
const it_explore_the_marketplace_and = en_explore_the_marketplace_and;

/** @type {(inputs: Explore_The_Marketplace_AndInputs) => LocalizedString} */
const ru_explore_the_marketplace_and = en_explore_the_marketplace_and;

/** @type {(inputs: Explore_The_Marketplace_AndInputs) => LocalizedString} */
const pt_explore_the_marketplace_and = en_explore_the_marketplace_and;

/** @type {(inputs: Explore_The_Marketplace_AndInputs) => LocalizedString} */
const ko_explore_the_marketplace_and = en_explore_the_marketplace_and;

/**
* | output |
* | --- |
* | "Explore the marketplace and heart items to save them here." |
*
* @param {Explore_The_Marketplace_AndInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const explore_the_marketplace_and = /** @type {((inputs?: Explore_The_Marketplace_AndInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explore_The_Marketplace_AndInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_explore_the_marketplace_and(inputs)
	if (locale === "es") return es_explore_the_marketplace_and(inputs)
	if (locale === "fr") return fr_explore_the_marketplace_and(inputs)
	if (locale === "de") return de_explore_the_marketplace_and(inputs)
	if (locale === "ja") return ja_explore_the_marketplace_and(inputs)
	if (locale === "zh") return zh_explore_the_marketplace_and(inputs)
	if (locale === "ar") return ar_explore_the_marketplace_and(inputs)
	if (locale === "id") return id_explore_the_marketplace_and(inputs)
	if (locale === "it") return it_explore_the_marketplace_and(inputs)
	if (locale === "ru") return ru_explore_the_marketplace_and(inputs)
	if (locale === "pt") return pt_explore_the_marketplace_and(inputs)
	return ko_explore_the_marketplace_and(inputs)
});